<template>
  <div class="tag-management">
    <div class="flex justify-between items-center pb-2 mb-3">
      <h4>Tags</h4>
      <vs-button @click="addTag = true">Add Tag</vs-button>
    </div>
    <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup" v-if="addTag" :class="{show: addTag}">
      <div class="cstm-modal medium fixed_medium">
        <div class="header">
          <h4>Add Tag</h4>
          <button @click="addTag = false" class="close-modal">&times;</button>
        </div>
        <form data-vv-scope="Tags" style="height: auto; max-height: 200px; overflow: auto; overflow-x: hidden;" class="modal-content p-4">
          <vs-row class="flex items-start">
            <vs-col class="p-2" vs-w="12">
              <vs-input
                icon-pack="feather"
                icon="icon-tag"
                placeholder="Type to create a tag and then add it"
                v-model="tag_name"
                class="is-label-placeholder mt-0 w-full"
                name="Tag"
                v-validate="'required'"
              />
              <span
                v-show="errors.has('Tags.Tag')"
                class="text-danger block"
                >{{ errors.first("Tags.Tag") }}</span
              >
            </vs-col>

            <vs-col class="p-2" vs-w="12">
              <v-select
                class="w-full"
                :options="platform_module"
                :reduce="(option) => option.id"
                label="module_name"
                v-model="tag_subject_id"
                v-validate="'required'"
                name="module"
                placeholder="Select Module"
              />
              <span
                v-show="errors.has('Tags.module')"
                class="text-danger block"
                >{{ errors.first("Tags.module") }}</span
              >
            </vs-col>

            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="center"
              vs-w="12"
              class="mt-3"
            >
              <vs-button color="primary" type="filled" @click.prevent="saveTag"
                >Add Tag</vs-button
              >
            </vs-col>
          </vs-row>
        </form>
      </div>
    </div>
    <div style="height: 400px; overflow: auto;" class="vertical_scrollbar">
      <vs-row class="all_tag_row_holder">
        <vs-col vs-lg="4" vs-sm="12" class="p-1">
          <div class="grey_border  p-2">
            <h5 class="mb-2">All Tags</h5>
            <div style="height: 175px; overflow: auto;" class="vertical_scrollbar">
              <div class="flex justify-between items-center" v-for="(eachTag, index) in allTag" :key="index">
                <vs-tooltip class="cstm-badge" :text="eachTag.name" color="primary" position="top">
                  <label>{{ eachTag.name }}</label>
                </vs-tooltip>
                <!-- <vs-button
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  @click="openConfirm(eachTag.id)"
                ></vs-button> -->
                <vs-icon style="cursor: pointer;" class="mr-1" icon-pack="feather" icon="icon-trash-2" @click="openConfirm(eachTag.id)"/>
              </div>
            </div>
          </div>
        </vs-col>
        <!-- <pre>{{tagWise}}</pre> -->
        <vs-col vs-lg="4" vs-sm="12"
          v-for="(eachModule, index) in tagWise"
          :key="index"
          class="p-1"
        >
          <div class="grey_border p-2">
              <h5 class="mb-2">
                {{ eachModule.module_name }}
              </h5>
              <div style="height: 175px; overflow: auto;" class="vertical_scrollbar">
                <div class="flex justify-between items-center" v-for="(eachTag, ind) in eachModule.tag"
                  :key="ind">
                  <vs-tooltip class="cstm-badge" :text="eachTag.name" color="primary" position="top">
                    <label>{{ eachTag.name }}</label>
                  </vs-tooltip>
                  <!-- <vs-button
                    color="danger"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-x"
                    @click="openConfirm(eachTag.id)"
                  ></vs-button> -->
                  <vs-icon style="cursor: pointer;" class="mr-1" icon-pack="feather" icon="icon-trash-2" @click="openConfirm(eachTag.id)"/>
                </div>
              </div>
          </div>
        </vs-col>
      </vs-row>
    </div>
  </div>
      <!-- <vs-col class="flex-col" vs-type="flex" vs-lg="3" vs-sm="6" vs-xs="12">
                <vs-collapse class="cstm-collapse">

                    <vs-collapse-item style="box-shadow: 0 4px 25px 0 rgba(0,0,0,.1)">
                        <div slot="header">
                            Homeworks
                        </div>
                           <div class="cstm-badge">
                            <label>Tag Name</label>
                            <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x"></vs-button>
                        </div>
                       
                       
                    </vs-collapse-item>
                </vs-collapse>
            </vs-col> -->
      <!-- <vs-col class="flex-col" vs-type="flex" vs-lg="3" vs-sm="6" vs-xs="12">
                <vs-collapse class="cstm-collapse">

                    <vs-collapse-item style="box-shadow: 0 4px 25px 0 rgba(0,0,0,.1)">
                        <div slot="header">
                            Exams
                        </div>
                        <div class="cstm-badge">
                            <label>Tag Name</label>
                            <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x"></vs-button>
                        </div>
                       
                    </vs-collapse-item>
                </vs-collapse>
            </vs-col> -->
      <!-- <vs-col class="flex-col" vs-type="flex" vs-lg="3" vs-sm="6" vs-xs="12">
                <vs-collapse class="cstm-collapse">

                    <vs-collapse-item style="box-shadow: 0 4px 25px 0 rgba(0,0,0,.1)">
                        <div slot="header">
                            Reports
                        </div>
                        <div class="cstm-badge">
                            <label>Tag Name</label>
                            <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x"></vs-button>
                        </div>
                      
                    </vs-collapse-item>
                </vs-collapse>
            </vs-col> -->
  
</template>

<script>
import { createTag, fetchingTag, fetchModule, deletingTag } from '@/api/tag.js'

import vSelect from 'vue-select'

export default {
  data () {
    return {
      addTag: false,
      tag_subject_id: '',
      tag_name: '',
      delete_tag_id: '',
      platform_module: [],
      allTag: [],
      tagWise: []
    }
  },

  components: {
    'v-select': vSelect
  },
  created () {
    this.fetchModule()
  },
  // mounted () {

  // },
  methods: {
    saveTag () {
      this.$validator.validateAll('Tags').then((valid) => {
        if (valid) {
          const payloadObject = {
            name: this.tag_name,
            platform_module_id: this.tag_subject_id
          }

          this.addingTag(payloadObject)
        } else {
        }
      })
    },
    setInitDefaultValue () {
      this.tag_name = ''
      this.questionbank_type = ''
    },
    async addingTag (payloadObject) {
      const customerId = this.$store.getters.customerId

      try {
        this.$vs.loading()
        const { data } = await createTag(payloadObject, customerId)
        this.$vs.notify({
          title: 'Success',
          text: 'Tag added successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })

        this.allTag.unshift(data.data.tag)
        // this.fetchTag()

        this.setInitDefaultValue()

        this.$validator.reset()

        this.moduleWiseTag()
      } catch (error) {
      } finally {
        this.$vs.loading.close()
      }
    },
    async fetchTag () {
      try {
        const customerId = this.$store.getters.customerId

        const { data } = await fetchingTag(customerId)
        this.allTag = data.data.tags

        // const platform_data = this.platform_module.map(ele => {
        //   return {
        //     id:ele.id,
        //     module_name:ele.module_name
        //   }
        // })

        //

        this.moduleWiseTag()
        //
      } catch (error) {}
    },

    moduleWiseTag () {
      const platform_data = this.platform_module.map((ele) => {
        return {
          id: ele.id,
          module_name: ele.module_name
        }
      })

      platform_data.forEach((element) => {
        const similarModuleTag = this.allTag.filter((ele) => {
          return element.id === ele.module.id
        })
        Object.assign(element, { tag: similarModuleTag })
      })
      this.tagWise = platform_data
    },
    async fetchModule () {
      try {
        const { data } = await fetchModule()

        this.platform_module = data.data
      } catch (error) {
        console.warn(error)
      } finally {
        this.fetchTag()
      }
    },
    openConfirm (id) {
      //
      this.delete_tag_id = id

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure you want to delete this tag?',
        accept: this.acceptAlert
      })
    },
    acceptAlert () {
      this.deleteTag(this.delete_tag_id)
    },
    async deleteTag (delete_id) {
      try {
        const customerId = this.$store.getters.customerId

        await deletingTag(customerId, delete_id)
        this.$vs.notify({
          title: 'Success',
          text: 'Tag deleted successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        this.fetchTag()
      } catch (error) {
        console.warn(error)
      }
    }
  }
}
</script>

<style>
.tag-management .vs-collapse {
  padding: 0;
  margin-bottom: 14px;
}
.tag-management .vs-collapse-item--header {
  padding: 14px 21px;
}
.cstm-collapse .vs-collapse-item--header {
  background-color: #fff;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
}
.cstm-collapse .vs-collapse-item--content {
  background-color: #fff;
}
.cstm_select {
  height: 38px;
}
.cstm_select .vs__dropdown-toggle {
  height: 100%;
}
.cstm-badge {
  display: inline-flex;
  align-items: center;
  background-color: #f1f6ff;
  margin: 2px 1px;
  padding: 0 0 0 10px;
  border-radius: 10rem;
}
.cstm-badge .vs-checkbox {
  width: 15px;
  height: 15px;
}
.cstm-badge button:hover {
  background: transparent !important;
}
</style>